import app from 'flarum/forum/app';
import m from 'mithril';
import { override } from 'flarum/common/extend';
import Footer from 'flarum/forum/components/Footer';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import SiteFooter from './components/SiteFooter';
import HomePage from './components/HomePage';
import modalPhoneFixes from './modalPhoneFixes';
import IndexNudges from './components/IndexNudges';
import blogIndex, { isFeed } from './blogIndex';
import articlePost from './articlePost';
import wikiBack from './wikiBack';
app.initializers.add('linkrobins-lr-home', () => {
  // Phone-only: no scroll lock, no focus trap. See modalPhoneFixes.
  modalPhoneFixes();

  // /all and the tag pages as a card feed; a discussion as an article.
  blogIndex();
  articlePost();

  // Back on wiki pages, which never pushed onto core's history.
  wikiBack();

  // Core's Footer renders nothing; give the whole site ours.
  override(Footer.prototype, 'view', () => m(SiteFooter));

  // The dashboard's review and tip nudges, under the discussion list's menu.
  // `override` rather than `extend`: the sidebar's items render into a <ul>,
  // and these are asides rather than menu entries, so they go AFTER the <nav>
  // as siblings — which is also where the .LrNudge styles expect them and how
  // the dashboard's own PageShell places them. Returning an array from view()
  // is a Mithril fragment; every child here is unkeyed, which keeps it out of
  // the mixed-keys trap.
  override(IndexSidebar.prototype, 'view', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    // The feed has no sidebar column to hang them under.
    if (isFeed()) return original(...args);
    return [original(...args), m(IndexNudges)];
  });
  // The home page is the first thing most visitors load, so it stays in the
  // main bundle. The rest load on demand: a discussion reader never opens
  // them, and parsing them on every page cost phones time (2026-10-11).
  app.routes['lr.home'] = {
    path: '/welcome',
    component: HomePage
  };
  app.routes['lr.about'] = {
    path: '/about',
    component: () => import(/* webpackChunkName: 'forum/components/AboutPage', webpackMode: 'lazy-once' */ './components/AboutPage')
  };
  app.routes['lr.wall'] = {
    path: '/wall-of-love',
    component: () => import(/* webpackChunkName: 'forum/components/WallPage', webpackMode: 'lazy-once' */ './components/WallPage')
  };
  app.routes['lr.tips'] = {
    path: '/tips',
    component: () => import(/* webpackChunkName: 'forum/components/TipsPage', webpackMode: 'lazy-once' */ './components/TipsPage')
  };
  app.routes['lr.contact'] = {
    path: '/contact',
    component: () => import(/* webpackChunkName: 'forum/components/ContactPage', webpackMode: 'lazy-once' */ './components/ContactPage')
  };
  app.routes['lr.terms'] = {
    path: '/terms',
    component: () => import(/* webpackChunkName: 'forum/components/LegalPage', webpackMode: 'lazy-once' */ './components/LegalPage')
  };
  app.routes['lr.privacy'] = {
    path: '/privacy',
    component: () => import(/* webpackChunkName: 'forum/components/LegalPage', webpackMode: 'lazy-once' */ './components/LegalPage')
  };
  app.routes['lr.cookie'] = {
    path: '/cookie',
    component: () => import(/* webpackChunkName: 'forum/components/LegalPage', webpackMode: 'lazy-once' */ './components/LegalPage')
  };

  // The main nav is managed in the admin panel with fof/links, not here — one
  // place to edit it, without a deploy.
});flarum.reg.addChunkModule('186', '418', 'linkrobins-lr-home', 'forum/components/AboutPage');
flarum.reg.addChunkModule('445', '595', 'linkrobins-lr-home', 'forum/components/WallPage');
flarum.reg.addChunkModule('355', '49', 'linkrobins-lr-home', 'forum/components/TipsPage');
flarum.reg.addChunkModule('765', '457', 'linkrobins-lr-home', 'forum/components/ContactPage');
flarum.reg.addChunkModule('838', '17', 'linkrobins-lr-home', 'forum/components/LegalPage');
flarum.reg.addChunkModule('838', '17', 'linkrobins-lr-home', 'forum/legalContent');